
import React from 'react';
import styled from 'styled-components';

const ShareButtonStyled = styled.button`
  background: #FF8C00; /* Arancione come il logo */
  color: white;
  border: none;
  border-radius: 50%; /* Rotondo come un'icona */
  width: 48px;
  height: 48px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(255, 140, 0, 0.3);

  &:hover {
    background: #FF7F00; /* Arancione più scuro al hover */
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 140, 0, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #6c757d;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

const ShareIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.50-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"/>
  </svg>
);

const ShareButton = ({ event }) => {
  const handleShare = async () => {
    // Genera l'URL dell'evento
    const eventUrl = `${window.location.origin}/evento/${event.id}`;
    const eventTitle = event.title || 'Evento interessante';
    
    // Formatta le date
    const formatDate = (dateString) => {
      if (!dateString) return '';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('it-IT', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return dateString;
      }
    };

    // Costruisci il messaggio completo
    let shareMessage = `🎉 ${eventTitle}\n\n`;
    
    // Aggiungi data inizio
    if (event.startDate) {
      const startDate = formatDate(event.startDate);
      shareMessage += `📅 Inizio: ${startDate}\n`;
    }
    
    // Aggiungi data fine
    if (event.endDate) {
      const endDate = formatDate(event.endDate);
      shareMessage += `🏁 Fine: ${endDate}\n`;
    }
    
    // Aggiungi luogo
    if (event.location) {
      shareMessage += `📍 Luogo: ${event.location}\n`;
    }
    
    // Aggiungi descrizione (limitata per evitare messaggi troppo lunghi)
    if (event.description) {
      const description = event.description.length > 150 
        ? event.description.substring(0, 150) + '...' 
        : event.description;
      shareMessage += `\n📝 ${description}\n`;
    }
    
    // Aggiungi prezzo se presente e diverso da 0
    if (event.ticketPrice && event.ticketPrice > 0) {
      shareMessage += `💰 Prezzo: €${event.ticketPrice}\n`;
    } else if (event.ticketPrice === 0) {
      shareMessage += `\n`;
    }
    
    shareMessage += `\n🔗 Scopri di più:`;

    // Controlla se il browser supporta l'API Web Share
    if (navigator.share) {
      try {
        await navigator.share({
          title: eventTitle,
          text: shareMessage,
          url: eventUrl,
        });
      } catch (error) {
        // L'utente ha annullato la condivisione o c'è stato un errore
        if (error.name !== 'AbortError') {
          console.error('Errore durante la condivisione:', error);
          fallbackShare(eventUrl, shareMessage);
        }
      }
    } else {
      // Fallback per browser che non supportano l'API Web Share
      fallbackShare(eventUrl, shareMessage);
    }
  };

  const fallbackShare = (url, message) => {
    // Crea il testo completo da copiare
    const fullText = `${message}\n${url}`;
    
    // Copia il testo completo negli appunti
    if (navigator.clipboard) {
      navigator.clipboard.writeText(fullText).then(() => {
        alert('Messaggio e link copiati negli appunti!');
      }).catch(() => {
        // Fallback per la copia
        copyToClipboardFallback(fullText);
      });
    } else {
      copyToClipboardFallback(fullText);
    }
  };

  const copyToClipboardFallback = (text) => {
    // Fallback per browser più vecchi
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      alert('Messaggio e link copiati negli appunti!');
    } catch (err) {
      console.error('Errore nella copia:', err);
      // Come ultimo fallback, mostra il testo completo in un prompt
      prompt('Copia questo messaggio:', text);
    } finally {
      document.body.removeChild(textArea);
    }
  };

  return (
    <ShareButtonStyled onClick={handleShare} title="Condividi evento">
      <ShareIcon />
    </ShareButtonStyled>
  );
};

export default ShareButton;
